import { Link } from "react-router-dom";
import "./index.scss";

const ButtonCta = ({ text, to }) => {


    return (
        <Link to={to}>
            <button className="cta-button">
                {text}
            </button>
        </Link>
    )
}

export default ButtonCta;